import Radium from "radium";

import AddAPhotoIcon from "material-ui/svg-icons/image/add-a-photo";

import WorkingIndicator from "./working-indicator.jsx";
import ImageDropzone from "./image-dropzone.jsx";

const STYLES = {
  outer: {
    boxShadow: "inset 1px 1px 60px 0 rgba(0,0,0,.45)",
    textAlign: "center",
    position: "relative",
    overflow: "hidden"
  },
  image: {
    width: "100%",
    display: "block"
  },
  instructions: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    opacity: 0.4,
    cursor: "pointer",
    transition: "0.25s all ease-in-out",
    ":hover": {
      opacity: 1
    }
  },
  instructionsWithValue: {
    opacity: 0
  },
  icon: {
    display: "block",
    width: 30,
    height: 30,
    margin: "0 auto 0.25em"
  },
  label: {
    fontWeight: "bold",
    fontSize: "1.2em"
  },
  sublabel: {
    marginTop: "0.25em",
    lineHeight: 1.1
  },
  subsublabel: {
    marginTop: "0.25em",
    fontSize: "0.9em"
  },
  deleteImage: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: "0 6px 4px",
    lineHeight: 1,
    fontSize: "1.5em",
    backgroundColor: "red",
    cursor: "pointer",
    borderRadius: "0 0 0 5px",
    ":hover": {
      backgroundColor: "#8B0000"
    }
  }
};

const DroppableImage = ({
  label,
  subsublabel,
  value,
  isUploading,
  invertLabelColor,
  style,
  onDrop,
  onDelete,
  ...rest
}) => {
  if (value) {
    invertLabelColor = true;
  }

  return (
    <ImageDropzone
      style={[STYLES.outer, style]}
      crop={true}
      hideCropTip={true}
      onDrop={([file]) => onDrop(file)}
      {...rest}
    >
      {value && <img src={value} style={STYLES.image} />}
      <div
        style={[
          STYLES.instructions,
          value && STYLES.instructionsWithValue,
          invertLabelColor && { color: "#fff" },
          invertLabelColor && !value && { opacity: 0.7 },
          isUploading && { opacity: 1 }
        ]}
      >
        <div key="upload">
          {isUploading ? (
            <div>
              <WorkingIndicator color={invertLabelColor ? "#fff" : "#ccc"} />
              <div
                style={{
                  marginTop: "0.5em",
                  color: invertLabelColor ? "#fff" : "#ccc"
                }}
              >
                Uploading...
              </div>
            </div>
          ) : (
            <div>
              <AddAPhotoIcon
                style={Object.assign(
                  {},
                  STYLES.icon,
                  invertLabelColor && { color: "#fff" }
                )}
              />
              <div style={STYLES.label}>{label}</div>
              <div style={STYLES.sublabel}>
                Drag and drop,
                <br />
                or click to upload.
              </div>
              <div style={STYLES.subsublabel}>{subsublabel}</div>
            </div>
          )}
        </div>
        {onDelete && value ? (
          <div
            key="delete"
            style={STYLES.deleteImage}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              onDelete();
            }}
          >
            &times;
          </div>
        ) : null}
      </div>
    </ImageDropzone>
  );
};

export default Radium(DroppableImage);



// WEBPACK FOOTER //
// ./src/app/components/partials/droppable-image.jsx